import { CloseOutlined } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from "@mui/material";
import Button from "@mui/material/Button";
import React from "react";
import { SelectInput, useRefresh } from "react-admin";
import sendRequest from "../dataProvider/sendRequest";
import CustomButtonSubmit from "../unit/CustomButtonSubmit";
import HmTextInput from "../unit/HmTextInput";
import formatPhone from "../unit/inputFormat/formatPhone";
import parsePhone from "../unit/inputFormat/parsePhone";
import useNotify from "../unit/useNotify";
import CustomButtonCancel from "../unit/CustomButtonCancel";
import { useForm, FormProvider } from "react-hook-form";
const CampaignAdd = (props: any) => {
  const refresh = useRefresh();
  const methods = useForm();
  const id = 99999;
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    refresh();
  };

  return (
    <>
      <Button
        id="btn-list-add-campaign"
        onClick={handleOpen}
        variant="text"
        color="primary"
        size="small"
        sx={{
          width: "120px",
          minWidth: "120px",
          color: "primary.main",
          "&.MuiButton-sizeSmall": {
            lineHeight: 1.5,
            fontSize: "0.875rem",
          },
        }}
      >
        <AddIcon sx={{ fontSize: "1.25rem" }} /> Landing Page
      </Button>
      <FormProvider {...methods}>
        <Dialog
          id="dialog-campaign-add"
          className="campaigns_add_dialog"
          open={open}
          onClose={handleClose}
          fullWidth={true}
          maxWidth="md"
          PaperProps={{
            component: "form",
            onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
              event.preventDefault();
              const formData = new FormData(event.currentTarget);
              let formJson = Object.fromEntries((formData as any).entries());
              console.log("formJson===>", formJson);
              const reqUrl = `campaigns/actions/add`;
              const response = await sendRequest(reqUrl, {
                id: "new",
                data: formJson,
              });
              // console.log(response.data);
              if (response && response.code == "200") {
                successNotify(
                  "Data saved successfully! Please add products to enable it!"
                );
                handleClose();
              } else {
                errorNotify(response?.message || "Data not saved!");
              }
            },
          }}
        >
          <DialogTitle
            sx={{
              fontWeight: "bold",
              mb: 2,
              borderBottom: "1px solid #e5e5e5",
              color: "#465384",
              textTransform: "uppercase",
            }}
          >
            Landing Page
            <IconButton
              style={{ position: "absolute", right: "10px", top: "10px" }}
              onClick={handleClose}
            >
              <CloseOutlined />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Box
              sx={{
                width: "100%",
                pt: 1,
                height: "50vh",
                maxHeight: "50vh",
              }}
            >
              <HmTextInput source="sName" label="Page Name" required={true} />
              <SelectInput
                sx={{ mt: 1 }}
                variant="outlined"
                source="sign_language"
                label="Sign-Up Page Language"
                choices={[
                  { id: "en", name: "English" },
                  {
                    id: "es",
                    name: "Spanish",
                  },
                  {
                    id: "ps",
                    name: "Pashto",
                  },
                ]}
                required={true}
                helperText={false}
              />
              <HmTextInput
                source="sSlogan"
                label="Welcome Headline"
                required={true}
              />
              <HmTextInput
                source="sWelcomeMsg"
                label="Welcome Message"
                rows={6}
                multiline={true}
                required={true}
              />
              <SelectInput
                source="security_signup"
                // label="Security for Sign-Up"
                label="Sign-Up Method"
                variant="outlined"
                choices={[
                  { id: "standard", name: "Standard" },
                  {
                    id: "counselor_assisted",
                    name: "Counselor Assisted",
                  },
                ]}
                required={true}
                helperText={false}
              />
            </Box>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "space-between" }}>
            <CustomButtonCancel onClick={handleClose} />
            <CustomButtonSubmit label="Generate" />
          </DialogActions>
        </Dialog>
      </FormProvider>
    </>
  );
};

export default CampaignAdd;
